module.exports = __webpack_public_path__ + "img/findAnswer.3bc04ced.png";